<template>
    <div>
        <div
            v-if="issubmit!=='3'"
            class="app-wrapper"
        >
            <NavBar />
            <section class="m_container">
                <Banner />
                <div
                    v-loading="loading"
                    class="whtie_wrap_tougao"
                >
                    <div class="form_wrap member_wrap">
                        <p class="form_tilte">{{ $t('tougao.basic_info') }}</p>
                        <div
                            v-if="memberHeader.length> 0"
                            class="form_list"
                        >
                            <div
                                v-for="(item,index) in memberHeader"
                                :key="index"
                            >
                                <div
                                    class="form_item"
                                    :style="[parentUploadStyle_(item)]"
                                >
                                    <RenderForm
                                        :data="member.info"
                                        :header="item"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form_wrap zuopin_wrap">
                        <p class="form_tilte">{{ $t('tougao.zuopin_info') }}</p>
                        <div
                            v-if="zuopinHeader.length > 0"
                            class="form_list"
                        >
                            <div
                                v-for="(item,index) in zuopinHeader"
                                :key="index"
                            >
                                <div
                                    class="form_item"
                                    :style="[ parentUploadStyle_(item) ]"
                                >
                                    <RenderForm
                                        :data="zuopin.info"
                                        :header="item"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="issubmit ==='1'"
                        class="footer"
                    >
                        <el-button
                            type="info"
                            class="submitbtn"
                            @click="back"
                        >{{ $t('tougao.cancel') }}</el-button>
                        <el-button
                            type="primary"
                            class="submitbtn"
                            @click="confirm"
                        >{{ $t('tougao.sure') }}</el-button>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
        <!-- 投稿回执 -->
        <div
            v-else
            v-loading="loading"
            class="app-wrapper"
            style="background: #fff;"
        >
            <div class="receipt-wrapper">
                <div class="hd">
                    <h2>{{ $t('tougao.receipt') }}</h2>
                    <p>NO.{{ ticket }}</p>
                </div>
                <div class="table_body">
                    <div
                        ref="con_left"
                        class="con_left uls"
                    >
                        <template v-if="memberHeader.length > 0">
                            <div
                                v-for="item in memberHeader"
                                :key="item.field"
                            >
                                <!-- Upload 上传 -->
                                <template v-if="item.type === 'upload' || item.type ==='CustomUpload'">
                                    <!-- 上传类型文件：图片、视频、文件 -->
                                    <div class="lis lis_upload">
                                        <RenderForm
                                            :data="member.info"
                                            :header="item"
                                            :is-table="true"
                                        />
                                    </div>
                                </template>
                                <!-- 其他表单 -->
                                <div
                                    v-else
                                    class="lis"
                                >
                                    <p class="f_label">{{ item.title }}</p>
                                    <p class="f_val">{{ member.info[item.field] }}</p>
                                </div>
                            </div>
                        </template>

                        <template
                            v-if="zuopinHeader.length > 0"
                            class="zuopin"
                        >
                            <div
                                v-for="(item,index) in zuopinHeader"
                                :key="item.field"
                                class="zuopin_1"
                                :class="{noZuopin: index >= zuopinHeader.length -1}"
                            >
                                <div
                                    v-if="item.field !== 'thumb_ids'"
                                    class="zuopin_2"
                                >
                                    <div
                                        v-if="item.type === 'upload' || item.type ==='CustomUpload'"
                                        class="lis lis_upload"
                                    >
                                        <RenderForm
                                            :data="zuopin.info"
                                            :header="item"
                                            :is-table="true"
                                        />
                                    </div>
                                    <div
                                        v-else
                                        class="lis"
                                    >
                                        <p class="f_label">{{ item.title }}</p>
                                        <p class="f_val">{{ zuopin.info[item.field] }}</p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div
                        class="con_right"
                        :style="{height:contentHeight}"
                    >
                        <div
                            v-if="thumb_ids_urls.length > 0"
                            class="img_wrap"
                        >
                            <!-- 作品 -->
                            <RenderUpload
                                :data="{thumb_ids_urls:thumb_ids_urls}"
                                :header="{field:'thumb_ids_urls'}"
                                :is-table="true"
                            />
                        </div>
                        <!-- 二维码 -->
                        <div class="img_wrap">
                            <VueQr
                                ref="h5Qrcode"
                                :text="`${qr_type_before}${zuopin_id}${qr_type_after}`"
                                :size="120"
                                class="qr"
                            />
                        </div>
                    </div>
                </div>
                <p class="tip">{{ tougaoSetting.note }}</p>
                <div class="center_flex">
                    <el-button
                        type="primary"
                        class="submitbtn"
                        @click="print"
                    >{{ $t('tougao.print') }}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 作品：路由参数 is_submit
 *      1: 提交
 *      0：查看
 *      3：回执单
 */
import VueQr from 'vue-qr'
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'
import Banner from '../home/component/banner'
import RenderForm from './component/renderForm.vue'
import RenderUpload from './component/renderUpload.vue'

import mixin from './mixin'
import { mapGetters } from 'vuex'
import { getTid, setTid } from '@/utils/cookies'
import { memberInfo, zuopinInfo, confirmZuopin } from '@/api/Tougaos'

export default {
    name: 'Confirm',
    components: { NavBar, Footer, Banner, VueQr, RenderForm, RenderUpload },
    mixins: [mixin],
    data() {
        return {
            loading: false,
            language: this.$store.getters.language,
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            zuopin_id: this.$route.query.zuopin_id,
            issubmit: this.$route.query.issubmit,
            ticket: '',
            member: { header: [], header_en: [], info: {} },
            zuopin: { header: [], header_en: [], info: {} },
            thumb_ids_urls: [], // 作品图片
            dialogVisible: false,
            imageUrl: '',
            qr_type_before: '',
            qr_type_after: '}',
            contentHeight: '0'
        }
    },
    beforeRouteEnter: (to, from, next) => {
        next(vm => {

        })
    },

    computed: {
        ...mapGetters(['tougaoSetting', 'domain']),
        parentUploadStyle_() {
            return (item) => {
                const bool = (item.type === 'upload' || item.type === 'CustomUpload') && (item.props.uploadType === 'image' || item.props.uploadType === 'file')
                return { marginBottom: bool ? '10px' : '0' }
            }
        },
        memberHeader() {
            const { header = [], header_en = [] } = this.member
            return this.language === 'en' ? header_en : header
        },
        zuopinHeader() {
            const { header = [], header_en = [] } = this.zuopin
            return this.language === 'en' ? header_en : header
        }
    },

    created() {
        this.qr_type_before = `{type: '0',ip:'${this.domain.app}',tid:'${this.tid}',id:`

        this.tid ? setTid(this.tid) : ''
        this.loading = true
        Promise.all([this.getMemberInfo(), this.getZuopinInfo(this.zuopin_id)])
            .then(res => {
                if (this.issubmit === '3') {
                    this.contentHeight = this.$refs.con_left.clientHeight < 396 ? '396px' : this.$refs.con_left.clientHeight + 'px'
                }
                setTimeout(() => {
                    this.loading = false
                }, 2000)
            })
    },

    methods: {
        getMemberInfo() {
            return new Promise((resolve, reject) => {
                memberInfo({ tid: this.tid }).then(res => {
                    if (res.code === 200) {
                        const { data, header, header_en } = res.data
                        this.member = {
                            header,
                            header_en,
                            info: data.info
                        }
                        // 数组转字符串
                        header.forEach(item => {
                            if ((item.type === 'cascader' || item.type === 'checkbox') && typeof (this.member.info[item.field]) === 'object' && item.type !== 'upload') {
                                this.member.info[item.field] = this.member.info[item.field].toString().replace(new RegExp(',', 'g'), '/')
                            }
                        })
                        resolve()
                    }
                })
            })
        },

        getZuopinInfo(id) {
            return new Promise((resolve, reject) => {
                zuopinInfo({ id }).then(res => {
                    if (res.code === 200) { // 作品信息 + form表单信息
                        const { data, header, header_en, category_header, category_header_en } = res.data
                        this.zuopin = {
                            header: [...header, ...category_header],
                            header_en: [...header_en, ...category_header_en],
                            info: data.info
                        }
                        this.ticket = data.ticket
                        // 数组转字符串
                        const zp_info = this.zuopin.info
                        this.zuopin.header.forEach(item => {
                            const { type, field } = item
                            if ((type === 'cascader' || type === 'checkbox') && typeof (zp_info[field]) === 'object' && type !== 'upload' && type !== 'CustomUpload') {
                                zp_info[field] = zp_info[field].toString().replace(new RegExp(',', 'g'), '/')
                            }
                            if (field === 'thumb_ids' && zp_info.thumb_ids && zp_info.thumb_ids.length) {
                                // this.thumb_ids_urls = typeof (zp_info[field]) === 'string' ? zp_info[field] : zp_info[field][0]
                                this.thumb_ids_urls = typeof (zp_info[field]) === 'string' ? zp_info[field] : type !== 'CustomUpload' ? zp_info[field][0] : zp_info[field][0].url
                            }
                        })
                        resolve()
                    }
                })
            })
        },

        back() {
            this.$router.go(-1)// 返回上一层
        },

        confirm() {
            this.$confirm(this.$t('tougao.submit_tip'), this.$t('Notification.tip'), {
                confirmButtonText: this.$t('tougao.sure'),
                cancelButtonText: this.$t('tougao.cancel'),
                type: 'warning'
            })
                .then(() => {
                    confirmZuopin({ id: this.zuopin_id, tid: this.tid }).then(() => {
                        this.$notify({
                            title: this.$t('tougao.suc_title'),
                            message: this.$t('tougao.suc_title'),
                            type: 'success',
                            duration: 2000
                        })
                        this.back()
                    })
                })
                .catch(() => { })
        },

        print() {
            window.print(0)
        },

        download(item) {
            window.open(item, '_blank')
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.app-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;

    .whtie_wrap_tougao {
        max-width: 1200px;
        min-height: 800px;
        margin: -80px auto 0;
        background: #fff;
        box-sizing: border-box;
        padding: 30px 200px;
        z-index: 100;
        .form_tilte {
            padding-bottom: 40px;
            margin-bottom: 38px;
            border-bottom: 1px solid #eeeeee;
            line-height: 48px;
            font-size: 24px;
            font-weight: bold;
            color: #000;
            position: relative;
            &::before {
                content: '';
                position: absolute;
                top: 8px;
                left: -14px;
                width: 6px;
                height: 30px;
                background: $theme_color;
                border-radius: 3px;
            }
        }

        .form_list {
            padding: 0 20px 0 200px;
            position: relative;
        }

        .footer {
            display: flex;
            margin-top: 60px;
        }

        .submitbtn {
            margin-left: 140px;
            width: 220px;
            height: 48px;
            line-height: 48px;
            padding: 0 20px;
            border-radius: 24px;
        }
    }
}

.form_value_flex {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .uploadImg {
        width: 80px;
        height: 80px;
        cursor: pointer;
    }
}

.receipt-wrapper {
    padding: 10px;
    width: 774px;
    margin: 0 auto;
    line-height: 24px;

    .hd {
        margin-bottom: 15px;
        line-height: 40px;

        h2 {
            font-size: 28px;
            text-align: center;
            font-family: PingFang;
        }

        p {
            text-align: center;
            line-height: 20px;
        }
    }

    .table_body {
        width: 100%;
        border: 1px solid;
        display: flex;
        justify-content: space-between;

        .con_left {
            height: auto;
            flex: 3;
            border-right: 1px solid;

            .lis {
                display: flex;
                justify-content: space-between;
                text-align: left;
                border-bottom: 1px solid;

                .f_label {
                    flex: 0 0 160px;
                    padding: 10px 15px;
                    border-right: 1px solid;
                    color: #999;
                    display: inline-block;
                    text-align: justify;
                    text-align-last: justify;
                }

                .f_val {
                    flex: 2;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding: 0 15px;

                    .zuopin_img {
                        width: 80px;
                        height: 80px;
                        cursor: pointer;
                    }
                }
            }

            .noZuopin {
                border-bottom: none !important;
                .lis {
                    border-bottom: none !important;
                }
            }
            .lis_upload {
                min-height: 80px;
                // line-height: 80px;
            }
        }

        .con_right {
            flex: 1;
            height: auto;
            width: 100%;
            padding: 10px 0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;

            .img_wrap {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 180px;
                }

                .uploadImg {
                    width: 180px;
                    height: 180px;
                    cursor: pointer;
                }
            }

            .img_wrap:last-child {
                border-bottom: none;
            }
        }
    }

    .tip {
        margin: 10px auto;
        font-size: 12px;
    }

    .center_flex {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .submitbtn {
        margin: 10px auto;
        text-align: center;
    }

    .qr {
        display: block;
        margin: 10px auto 0;
    }
}

@media screen and (max-width: 1260px) {
    .app-wrapper {
        .banner_wrap {
            .title {
                font-size: 30px;
            }
        }
    }
}
</style>
